/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ShadowMCPInventoryRequestSummary = {
  id: string;
  policyId: string;
  requestedAt: Date;
  requesterEmail: string;
  requesterUserId: string;
};

/** @internal */
export const ShadowMCPInventoryRequestSummary$inboundSchema: z.ZodMiniType<
  ShadowMCPInventoryRequestSummary,
  unknown
> = z.pipe(
  z.object({
    id: z.string(),
    policy_id: z.string(),
    requested_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    requester_email: z.string(),
    requester_user_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "policy_id": "policyId",
      "requested_at": "requestedAt",
      "requester_email": "requesterEmail",
      "requester_user_id": "requesterUserId",
    });
  }),
);

export function shadowMCPInventoryRequestSummaryFromJSON(
  jsonString: string,
): SafeParseResult<ShadowMCPInventoryRequestSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ShadowMCPInventoryRequestSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ShadowMCPInventoryRequestSummary' from JSON`,
  );
}
